import React, { useState } from "react";
import { InputContainer } from "..";
import { Chrome, hsvaToHex, Swatch } from "@uiw/react-color";
import { Pick, Content, styleSwatch, PRESET_COLORS } from "./ColorInput.styled";
import { Popover } from "../../Overlays";
import { PopoverContent } from "../../Overlays/Popover/Popover";

export const ColorInput = ({
  label,
  value,
  onChange,
  isRequired = false,
  flex = 1,
  width = "100%",
  palette = null,
  showPalette = false
}) => {
  const [open, setOpen] = useState(false);

  return (
    <InputContainer
      label={label}
      isRequired={isRequired}
      flex={flex}
      width={width}
      render={(ID) => (
        <Popover
          open={open}
          onOpenChange={setOpen}
          trigger={<Pick onClick={() => setOpen(true)} color={value} />}
        >
          <PopoverContent>
            <Content>
              <Chrome
                id={ID}
                inputType="hexa"
                color={value}
                onChange={(color) => {
                  onChange(color.hexa);
                }}
              />
              {showPalette && (
                <Swatch
                  style={styleSwatch}
                  colors={palette || PRESET_COLORS}
                  color={value}
                  onChange={(color) => {
                    onChange(hsvaToHex(color));
                  }}
                />
              )}
            </Content>
          </PopoverContent>
        </Popover>
      )}
    />
  );
};
